import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import { Container } from './styles';

interface CheckboxInputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  onChange?: (e: any) => void;
}

const ToggleOnOff: React.FC<CheckboxInputProps> = ({
  name,
  label,
  onChange = (): void => undefined,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: (ref: HTMLInputElement) => {
        return ref.checked;
      },
    });
  }, [fieldName, registerField]);

  return (
    <Container>
      <label className="switch" htmlFor={rest.id || name}>
        {label}
        <input
          id={name}
          type="checkbox"
          ref={inputRef}
          name={fieldName}
          defaultChecked={defaultValue}
          onChange={(): void => onChange(inputRef.current?.checked)}
          {...rest}
        />
        <span className="slider" />
      </label>
    </Container>
  );
};

export default ToggleOnOff;
